<template>
    <v-card
            height="400"
            width="300"
            class="mx-auto mt-6"
            color="#fafafa"
    >
        <v-card-title class="title">
            <slot name="title"></slot>
        </v-card-title>
        <v-card-text
                class="text-center text"
        >
            <div
                    class="content"
            >
                <slot></slot>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "Card"
    }
</script>

<style scoped>
    .content {
        margin-top: 30%;
        /*background-color: aqua;*/
    }
    .text {
        /*background-color: #42b983;*/
    }
    .title {
        /*background-color: bisque;*/
    }
</style>